module.exports = __webpack_public_path__ + "static/pic01-c918ec0e0c1b25b4fe64f38b63754a9c.jpg";